import React, { memo } from "react";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";
import { useHusibuechContext } from "../../context/husibuechContext";
import MiddleBox from "../1_Boxes/MiddleBox";
import AssignmentAddCard from "./AssignmentAddCard";
import BoxHeader from "../../components/1_Boxes/BoxHeader";

function AssignmentAddBox({
  flipAssignment,
  setFlipAssignment,
  type,
  date,
  handleClose,
  boxType,
  single,
}) {
  const { currentUser } = useAppContext();
  const { isALeader, isAReferenceStudent } = useHusibuechContext();

  return (
    <>
      <BoxHeader
        title={"Neues Assignment erfassen"}
        options={!type && !single ? ["flipAssignment"] : []}
        flipAssignment={flipAssignment}
        setFlipAssignment={setFlipAssignment}
      />
      <MiddleBox>
        {currentUser && (
          <AssignmentAddCard
            handleClose={handleClose}
            date={date}
            restricted={!(isALeader || isAReferenceStudent)}
          />
        )}
      </MiddleBox>
    </>
  );
}
export default memo(AssignmentAddBox);
